import { Finding } from '@/api/domains/analyses/types';
import styles from './ComparisonView.module.css';
import { ComparisonColumn } from './components';

interface ComparisonViewProps {
  finding: Finding;
  document1Name: string;
  document2Name: string;
  document1Source: string;
  document2Source: string;
}

export const ComparisonView = ({
  finding,
  document1Name,
  document2Name,
  document1Source,
  document2Source
}: ComparisonViewProps) => {
  return (
    <div className={styles.comparisonCard}>
      <div className={styles.comparisonGrid}>
        <ComparisonColumn
          finding={finding}
          documentName={document1Name}
          documentSource={document1Source}
          sectionId={finding.section_1_id}
          isDoc1={true}
        />
        <ComparisonColumn
          finding={finding}
          documentName={document2Name}
          documentSource={document2Source}
          sectionId={finding.section_2_id}
          isDoc1={false}
        />
      </div>
    </div>
  );
};
